module.exports = __webpack_public_path__ + "static/img/themify.9c8e96e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.svg?-fvbane
// module id = 472
// module chunks = 0 1 2 3 4